export var FloatingButtonExtendedVariants;
(function (FloatingButtonExtendedVariants) {
    FloatingButtonExtendedVariants["PRIMARY"] = "PRIMARY";
})(FloatingButtonExtendedVariants || (FloatingButtonExtendedVariants = {}));
export var FloatingButtonExtendedThemeStates;
(function (FloatingButtonExtendedThemeStates) {
    FloatingButtonExtendedThemeStates["PRESSED"] = "PRESSED";
    FloatingButtonExtendedThemeStates["LOADING"] = "LOADING";
    FloatingButtonExtendedThemeStates["DISABLED"] = "DISABLED";
})(FloatingButtonExtendedThemeStates || (FloatingButtonExtendedThemeStates = {}));
//# sourceMappingURL=floatingButtonExtendedTheme.js.map